<template>
    <div v-if="isLargeScreen">
        <div v-show="showLevel2" class="row align-items-center gx-0 px-0 nav-level-2">

            <ul class="navbar-nav my-2 my-lg-0 navbar-nav-scroll justify-content-center align-items-center flex-row flex-wrap m-0"
                style="--bs-scroll-height: 100px;">

                <!-- Links normales -->
                <li class="nav-item">
                    <router-link to="/Home" class="nav-link active menuitem">
                        <span>Home</span>
                    </router-link>
                </li>

                <li class="nav-item">
                    <router-link to="/contacto" class="nav-link active menuitem">
                        <span>Contacto</span>
                    </router-link>
                </li>

                <li class="nav-item">
                    <router-link to="/ListBlogs" class="nav-link active menuitem">
                        <span>Blog</span>
                    </router-link>
                </li>

                <li class="nav-item">
                    <router-link to="/ProdsMX" class="nav-link active menuitem">
                        <span>Hecho en México</span>
                    </router-link>
                </li>

                <li class="nav-item">
                    <router-link to="/OurBrands" class="nav-link active menuitem">
                        <span>Nuestras Marcas</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/catalogosview" class="nav-link active menuitem">
                        <span>Catálogos</span>
                    </router-link>
                </li>
                <!-- MEGA MENU -->
                <!--<li class="nav-item dropdown position-static">
                    <a class="nav-link dropdown-toggle menuitem" href="#" id="megaDropdown" data-bs-toggle="dropdown">
                        Categorías
                    </a>

                    <div class="dropdown-menu mega-dropdown w-100 mt-0 p-4">
                        <div v-if="!categoriasCargadas" class="row">
                            <div class="col-12 col-md-4 col-lg-2 mb-4" v-for="n in 6" :key="'skeleton-' + n">
                                <div class="mega-header">
                                    <div class="skeleton-title"></div>
                                </div>

                                <ul class="mega-list list-unstyled">
                                    <li v-for="i in 5" :key="'linea-' + i">
                                        <div class="skeleton-line"></div>
                                    </li>
                                </ul>

                                <div class="skeleton-button"></div>
                            </div>
                        </div>

                        <div class="row" v-else>
                            <div class="col-12 col-md-4 col-lg-2 mb-4" v-for="categoria in categorias"
                                :key="categoria.id">
                                <div class="mega-header">
                                    <i class="bi bi-laptop"></i>
                                    <h5 class="mega-title">{{ categoria.name }}</h5>
                                </div>

                                <ul class="mega-list list-unstyled">
                                    <li v-for="linea in categoria.lineas" :key="linea.id_linea">
                                        <router-link class="mega-link"
                                            :to="{ name: 'ListadoProductosLinea', params: { id: linea.id_linea, linea: linea.linea } }"
                                            @click.native="cerrarDropdown">
                                            {{ linea.linea }}
                                        </router-link>
                                    </li>
                                </ul>

                                
                            </div>
                        </div>

                        
                    </div>
                </li>-->
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isLargeScreen: Boolean,
        showLevel2: Boolean
    },

    data() {
        return {
            categorias: [],          // aquí llegan las marcas con sus líneas
            categoriasCargadas: false,
            dropdownListener: null
        };
    },

    mounted() {
        const dropdown = document.getElementById("megaDropdown");

        if (!dropdown) {
            console.warn("megaDropdown no encontrado en el DOM");
            return;
        }

        // Guardamos referencia para poder removerlo después
        this.dropdownListener = () => {
            if (!this.categoriasCargadas) {
                this.cargarCategorias();
            }
        };

        dropdown.addEventListener("show.bs.dropdown", this.dropdownListener);
    },

    beforeUnmount() {
        // Evita fugas de memoria
        const dropdown = document.getElementById("megaDropdown");
        if (dropdown && this.dropdownListener) {
            dropdown.removeEventListener("show.bs.dropdown", this.dropdownListener);
        }
    },

    methods: {
        async cargarCategorias() {
            try {
                const res = await axios.get('/api/home/Salescategorias');  // <---- TU NUEVO ENDPOINT
                this.categorias = res.data;
                this.categoriasCargadas = true;
            } catch (error) {
                console.error("Error cargando categorías:", error);
            }
        },
        cerrarDropdown() {
            const dropdownEl = document.getElementById('megaDropdown');
            const dropdown = bootstrap.Dropdown.getInstance(dropdownEl);
            if (dropdown) dropdown.hide();
        }
    }
};
</script>


<style scoped>
/* ============================================
   MEGA MENU PREMIUM – DARK GLASS AZUL METÁLICO
   ============================================ */

.mega-dropdown {
    background: rgba(6, 40, 60, 0.90);
    /* glass oscuro */
    backdrop-filter: blur(6px);
    /* desenfoque elegante */
    -webkit-backdrop-filter: blur(6px);

    border-top: 4px solid #1CA3DF;
    /* azul metálico */
    box-shadow:
        inset 0 0 12px rgba(255, 255, 255, .05),
        /* brillo interno */
        0px 18px 35px rgba(0, 0, 0, .35);
    /* profundidad */

    animation: megaSlide .25s ease-out;
    /* animación al abrir */
    padding: 1.8rem !important;
}


/* Animación suave al desplegar */
@keyframes megaSlide {
    from {
        transform: translateY(10px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}


/* ============================================
   COLUMNAS
   ============================================ */

.mega-dropdown .col-md-4 {
    border-right: 1px solid rgba(255, 255, 255, .07);
}

.mega-dropdown .col-md-4:last-child {
    border-right: none;
}


/* ============================================
   TÍTULOS
   ============================================ */

.mega-title {
    color: #ffffff;
    font-size: 1rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .5px;
    margin-bottom: 1rem;
    transition: .25s ease;
}

.mega-title:hover {
    color: #1CA3DF;
    /* azul metálico */
}


/* ============================================
   LINKS
   ============================================ */

.mega-list .mega-link {
    display: block;
    padding: 4px 0;
    color: rgba(255, 255, 255, .94);
    font-size: .93rem;
    text-decoration: none;
    transition: .20s ease;
}

.mega-list .mega-link:hover {
    transform: translateX(6px);
    color: #1CA3DF;
    /* glow azul */
}


/* ============================================
   BOTÓN “VIEW MORE”
   ============================================ */

.btn-view {
    background: #1CA3DF;
    color: white;
    border: none;
    padding: .4rem .8rem;
    border-radius: 4px;
    font-size: .82rem;
    font-weight: 600;
    box-shadow: 0 3px 10px rgba(28, 163, 223, .35);
    transition: .25s ease;
}

.btn-view:hover {
    background: #168CBC;
    box-shadow: 0 5px 18px rgba(28, 163, 223, .45);
}


/* ============================================
   CTA INFERIOR
   ============================================ */

.mega-cta {
    margin-top: 1.3rem;
    background: #1CA3DF;
    color: white;
    padding: .65rem 1rem;
    border-radius: 4px;
    font-weight: 600;
    display: inline-block;
    box-shadow: 0 3px 12px rgba(28, 163, 223, .35);
    transition: .25s ease;
}

.mega-cta:hover {
    background: #168CBC;
    box-shadow: 0 5px 20px rgba(28, 163, 223, .45);
}


/* ============================================
   RESPONSIVE
   ============================================ */

@media (max-width: 991px) {
    .mega-dropdown {
        position: static !important;
        backdrop-filter: none;
        background: #06283C;
        box-shadow: none;
    }

    .mega-dropdown .col-md-4 {
        border-right: none !important;
        margin-bottom: 1rem;
    }
}
</style>
